export default __webpack_public_path__ + "static/media/ig-logo.d9be23dd.png";